// extracted by mini-css-extract-plugin
export default {"site-display-name":"MediumFilterItem_site-display-name__NjWmN"};